import { Container, Row, Col } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { FaMapMarkerAlt, FaFacebookF, FaTwitter, FaLinkedinIn, FaPinterestP, FaEnvelope, FaPhoneAlt } from 'react-icons/fa';
import logo from '../../Assets/logo.png';
import './Footer.css';

const MAPS_URL =
  'https://www.google.com/maps/dir//%D8%A7%D9%85%D8%A7%D9%85+%D8%A8%D9%86%D9%83%D8%8C+2+%D9%85%D8%AA%D9%81%D8%B1%D8%B9+%D9%85%D9%86+%D8%B4+%D9%85%D8%AD%D9%85%D8%AF+%D9%81%D8%B1%D9%8A%D8%AF%D8%8C%D8%8C+%D8%A7%D9%84%D9%81%D9%88%D8%A7%D9%84%D8%A9%D8%8C+%D8%B9%D8%A7%D8%A8%D8%AF%D9%8A%D9%86%D8%8C+%D9%85%D8%AD%D8%A7%D9%81%D8%B8%D8%A9+%D8%A7%D9%84%D9%82%D8%A7%D9%87%D8%B1%D8%A9';

const QUICK_LINKS = [
  { to: '/about', label: 'About' },
  { to: '/Courseslist', label: 'Programs' },
  { to: '/blog', label: 'Blog' },
  { to: '/Library', label: 'Publications' },
  { to: '/contact', label: 'Contact' },
];

const SOCIALS = [
  { href: 'https://www.facebook.com/profile.php?id=100083012838300', label: 'Facebook', Icon: FaFacebookF },
  { href: 'https://twitter.com', label: 'Twitter', Icon: FaTwitter },
  { href: 'https://linkedin.com', label: 'LinkedIn', Icon: FaLinkedinIn },
  { href: 'https://pinterest.com', label: 'Pinterest', Icon: FaPinterestP },
];

const Footer = () => {
  return (
    <footer className="footer">
      <Container>
        <Row className="footer__main gy-5">
          {/* Brand */}
          <Col xs={12} lg={4}>
            <img src={logo} alt="Centro Culturale Francescano" className="footer__logo" />
            <p className="footer__about">
              Centro Culturale Francescano — Coptic studies, publishing and heritage research in Cairo.
            </p>
          </Col>

          {/* Quick links */}
          <Col xs={12} sm={6} lg={2}>
            <h4 className="footer__title">Quick Links</h4>
            <ul className="footer__list">
              {QUICK_LINKS.map(({ to, label }) => (
                <li key={to}>
                  <Link to={to} className="footer__link">{label}</Link>
                </li>
              ))}
            </ul>
          </Col>

          {/* Contact */}
          <Col xs={12} sm={6} lg={3}>
            <h4 className="footer__title">Contact</h4>
            <ul className="footer__list">
              <li className="footer__item">
                <FaPhoneAlt className="footer__icon" />
                <span dir="ltr">010 00714875</span>
              </li>
              <li className="footer__item">
                <FaEnvelope className="footer__icon" />
                <a href="mailto:f.centroculturale@gmail.com" className="footer__link">f.centroculturale@gmail.com</a>
              </li>
            </ul>
          </Col>

          {/* Location + follow */}
          <Col xs={12} lg={3}>
            <h4 className="footer__title">Location</h4>
            <address className="footer__address">
              كنيسة ودير سان جوزيف - ٢ ش بنك مصر - متفرع من محمد فريد - وسط البلد, Cairo, Egypt
            </address>
            <a href={MAPS_URL} target="_blank" rel="noopener noreferrer" className="footer__directions">
              <FaMapMarkerAlt /> Get directions
            </a>

            <h4 className="footer__title footer__title--follow">Follow</h4>
            <div className="footer__social">
              {SOCIALS.map(({ href, label, Icon }) => (
                <a key={label} href={href} className="footer__social-link" aria-label={label} target="_blank" rel="noopener noreferrer">
                  <Icon />
                </a>
              ))}
            </div>
          </Col>
        </Row>

        <div className="footer__bottom">
          <p className="footer__copyright">
            &copy; {new Date().getFullYear()} Centro Culturale Francescano. All rights reserved.
          </p>
        </div>
      </Container>
    </footer>
  );
};

export default Footer;
